export const DATA_HOOKS = {
  COLOR_INPUT_COLOR_PICKER: 'colorinput-colorpicker',
  COLOR_INPUT_VIEWER: 'colorinput-viewer',
  COLOR_INPUT_HASH: 'colorinput-hash',
  COLOR_PICKER_SWATCHES: 'color-picker-swatches',
  COLOR_INPUT_VIEWER_LINE: 'colorinput-viewer-line',
  COLOR_INPUT_POPOVER: 'colorinput-popover',
};
